import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberPersonalInformationOnboardingFormGroup } from '../member-personal-information-onboarding-form-group';
import { Pronoun } from '../../../../../models/users/dto/pronoun';
import { Gender } from '../../../../../models/types/dto/gender';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropDownItem } from '../../../../../models/shared/stylesheet/drop-down-item';

@Component({
  selector: 'app-member-onboarding-modal-personal-information-form',
  templateUrl: './member-onboarding-modal-personal-information-form.component.html',
  styleUrls: ['./member-onboarding-modal-personal-information-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberOnboardingModalPersonalInformationFormComponent implements OnChanges {
  @Input() form!: MemberPersonalInformationOnboardingFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() pronouns: Pronoun[] = [];
  @Input() genders: Gender[] = [];

  private _genders = new BehaviorSubject<Gender[]>([]);
  public genders$ = this._genders as Observable<Gender[]>;

  private _pronouns = new BehaviorSubject<Pronoun[]>([]);
  public pronouns$ = this._pronouns as Observable<Pronoun[]>;

  public genderDropdowns$ = this.genders$.pipe(
    map(genders => {
      return genders.map(g => new DropDownItem(g?.name, g?.id));
    })
  );

  public pronounDropdowns$ = this.pronouns$.pipe(
    map(pronouns => {
      return pronouns.map(p => new DropDownItem(p?.name, p?.id));
    })
  );

  public customErrorMessages = {
    genderId: {
      required: $localize`Selection is required`
    },
    pronounId: {
      required: $localize`Selection is required`
    }
  };

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.genders) {
      this._genders.next(this.genders);
    }
    if (changes.pronouns) {
      this._pronouns.next(this.pronouns);
    }
  }
}
